import { type TranslationSchema } from '~/locales/resources'

export const dataDisplayTypes = [
  'percentage',
  'number',
  'estimatedPopulation',
] as const

export type DataDisplayType = (typeof dataDisplayTypes)[number]

export const dataDisplayTypeLabelI18nKeyMap = {
  percentage: 'percentage',
  number: 'sample_size',
  estimatedPopulation: 'estimated_population',
} as const satisfies Record<DataDisplayType, keyof TranslationSchema>
